import m from "../../geodata/es2015/argentinaLow";
window.am4geodata_argentinaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/argentinaLow.js
// module id = null
// module chunks = 